import styled from 'styled-components';
import { portalCardsContainerStyle, portalCardsContainerWithSidebarStyle } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.section`
    align-self: center;
    width: 100%;
    align-items: center;
    &.sidebar-opened {
        ${portalCardsContainerWithSidebarStyle}
    }
    &.sidebar-closed {
        ${portalCardsContainerStyle}
    }
    margin-top: ${token('space.400', '32px')};
`;
